
export default {
  paymentDetails: "تفاصيل الدفع",
  totalCampaignCost: "التكلفة الإجمالية للحملة",
  termsAndConditions: "الشروط والأحكام",
  acceptTerms: "أوافق على الشروط والأحكام",
  campaignSubmitted: "تم إرسال الحملة",
  campaignSubmittedDesc: "شكراً لك! تم إرسال حملتك بنجاح. ستتم معالجتها قريبًا.",
  totalAmount: "المبلغ الإجمالي",
  bankTransfer: "تحويل بنكي",
  creditCard: "بطاقة ائتمان",
  iban: "رقم الحساب البنكي الدولي",
  bankName: "اسم البنك",
  emailAddress: "البريد الإلكتروني",
  bankTransferInstructions: "يرجى تحويل المبلغ إلى الحساب المصرفي أدناه وإرسال إيصال التحويل إلينا عبر البريد الإلكتروني. ستبدأ حملتك بعد تأكيد الدفع.",
  processing: "جاري المعالجة...",
  saveAndStartCampaign: "حفظ وبدء الحملة",
  campaignCreated: "تم إنشاء الحملة بنجاح!",
  payNow: "الدفع الأن",
  payLater: "الدفع لاحقًا",
  
  // Updated translations
  completePayment: "إكمال الدفع",
  choosePaymentMethod: "اختر طريقة الدفع الخاصة بك",
  
  // New translations
  campaignSubmittedTitle: "تم إنشاء الحملة بنجاح!",
  campaignSubmittedDescription: "تم تقديم حملتك بنجاح وهي الآن قيد المراجعة من قبل فريقنا.",
  campaignViewInstructions: "احصل على رؤى وتحليلات لحملتك في لوحة معلومات العملاء الحصرية",
  visitClientPortal: "الوصول إلى لوحة المعلومات",
  closeAndStayHere: "إنشاء حملة أخرى",
  
  // Validation messages
  campaignValidationFailed: "يرجى إكمال جميع الخطوات السابقة قبل المتابعة إلى الدفع.",
  
  // Quotation System
  invoice: "عرض أسعار",
  invoiceNumber: "رقم عرض الأسعار",
  invoiceDate: "التاريخ",
  downloadInvoice: "تحميل عرض الأسعار",
  viewInvoice: "عرض الأسعار",
  invoiceStatus: "الحالة",
  invoicePaid: "مدفوعة",
  invoicePending: "قيد الانتظار",
  invoiceDetails: "تفاصيل عرض الأسعار",
  billingDetails: "تفاصيل العميل",
  paymentMethodDetails: "تفاصيل طريقة الدفع",
  paymentMethod: "طريقة الدفع",
  paymentDate: "التاريخ",
  paymentTotal: "إجمالي المبلغ",
  vatIncluded: "متضمن ضريبة القيمة المضافة",
  close: "إغلاق",
  loading: "جاري تحميل المستند...",
  
  // Tax Invoice System
  taxInvoice: "فاتورة ضريبية",
  taxInvoiceForm: "بيانات الفاتورة الضريبية",
  taxInvoicePreview: "معاينة الفاتورة",
  generateTaxInvoice: "إنشاء الفاتورة",
  invoiceGenerated: "تم إنشاء الفاتورة بنجاح",
  invoiceGenerating: "جاري إنشاء الفاتورة...",
  vatNumber: "رقم التسجيل الضريبي",
  companyAddress: "عنوان الشركة",
  city: "المدينة",
  postalCode: "الرمز البريدي",
  commercialRegistration: "السجل التجاري",
  pricePerDay: "السعر لليوم الواحد",
  amountPaid: "المبلغ المدفوع",
  remainingBalance: "المتبقي",
  subtotal: "المجموع الفرعي",
  netTotal: "الصافي",
  seller: "البائع",
  buyer: "المشتري",
  requiredBillingInfo: "بيانات الفوترة المطلوبة",
  addressRequired: "العنوان مطلوب",
  cityRequired: "المدينة مطلوبة",
  postalCodeRequired: "الرمز البريدي مطلوب",
  vatNumberRequired: "رقم التسجيل الضريبي مطلوب",
  invalidVatNumber: "رقم ضريبي غير صالح (يجب أن يكون 15 رقم يبدأ بـ 3)",
  confirmAndProceed: "تأكيد والمتابعة",
} as const;
